import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthHttp } from '../../../services/http/http.service';
import { buscarPorCodigo } from '../../../services/catalogo/buscar-por-codigo';
import { requestWithFallback, requestWithResponse } from '../../../services/http/request-with-response';

@Injectable()
export class ProveedoresService {
  public current: any;
  public currentFabricantes: any;
  public currentProveedores: any;
  public currentTarifas: any;

  constructor(private readonly http: AuthHttp) {}

  flush() {
    this.currentFabricantes = [];
    this.currentProveedores = [];
  }

  getFromEmpresa(empresa_id) {
    return this.postWithState(
      `${environment.apiURLs.private}/empresa/${empresa_id}/proveedor_articulos`,
      response => { this.currentProveedores = response; },
      'No se pudo obtener la información de proveedores'
    );
  }

  getTarifaFromEmpresa(empresa_id) {
    return this.postWithState(
      `${environment.apiURLs.private}/empresa/${empresa_id}/tarifas`,
      response => { this.currentTarifas = response; },
      'No se pudo completar la operación de proveedores'
    );
  }

  getFabricantes(cdg_grupo: string) {
    const dominio = localStorage.getItem('dominio');
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/fabricantes`, {
      cdggrupo: cdg_grupo,
      dominio: dominio
    }), response => { this.currentFabricantes = response; },
    () => new Error('No se pudo completar la operación de proveedores'));
  }

  getFabricanteFromCodigo(codigo: string, fabricantes?: any[]) {
    return buscarPorCodigo(fabricantes || this.currentFabricantes, codigo);
  }

  private postWithState(url: string, onSuccess: (response: any) => void, errorMessage: string) {
    const dominio = localStorage.getItem('dominio');
    return requestWithResponse(
      this.http.post(url, { dominio }),
      onSuccess,
      () => new Error(errorMessage)
    );
  }

  guardarProveedor(empresa_id, proveedor_id, proveedor) {
    const dominio = localStorage.getItem('dominio');
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/proveedor_articulos/${proveedor_id}/editar`, { proveedor, dominio }),
      () => undefined, () => new Error('No se pudo completar la operación de proveedores'));
  }

  getSucursalesConfiguradas(fabricante_id: any, empresa_id: any) {
    return requestWithFallback(this.http.get(`${environment.apiURLs.private}/tienda_fabricante/${fabricante_id}/empresa/${empresa_id}`), []);
  }

  getConfiguracion(proveedor_id: any, empresa_id: any, tarifa_id: any, tienda_id: any) {
    const dominio = localStorage.getItem('dominio');
    return requestWithFallback(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/proveedor_articulos/${proveedor_id}/obtenerconf`, {
      tarifa: tarifa_id, tienda_id, dominio
    }), []);
  }

  guardarConfiguracion(proveedor_id: any, empresa_id: any, proveedor_nombre: any, tienda_id: any, valoresPedido: any) {
    const dominio = localStorage.getItem('dominio');
    return requestWithFallback(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/proveedor_articulos/${proveedor_id}/actualizar_config`, {
      proveedor_nombre, tienda_id, valoresPedido, dominio
    }), []);
  }

  getTipoConexion(proveedor_id: any, empresa_id: any, tarifa_id: any) {
    const dominio = localStorage.getItem('dominio');
    return requestWithFallback(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/proveedor_articulos/${proveedor_id}/obtenerTipoConexion`, {
      tarifa: tarifa_id, dominio
    }), []);
  }
}
